import React, {useContext, useEffect, useState} from 'react';
import styled from '@emotion/styled';
import {fontSize} from "patient-ping-remedy/packages/theme";
import {BackendVersions} from "@/api/dto/dto";
import {CarecoApiContext} from "@/app-context/careco-api-context";
import {log} from "@/helpers/logger";
import InfoIconTooltip from "@common/InfoIconTooltip";

const Wrapper = styled('div')`
  position: relative;
  
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  
  font-size: ${fontSize.small};
`;

const Table = styled('table')`
  border-collapse: collapse;
  margin: 40px auto 0;

  tr th:first-of-type {
    border-left: none;
  }

  tr th:last-child {
    border-right: none;
  }

  tr td:first-of-type {
    border-left: none;
    font-weight: bold;
  }

  tr td:last-child {
    border-right: none;
  }

  tr:first-of-type th {
    border-top: none;
  }

  tr:last-child td {
    border-bottom: none;
  }
`;

const HeaderCell = styled('th')`
  border: 1px solid black;
  border-top: none;
  padding: 2px 8px;
`;

const Cell = styled('td')`
  border: 1px solid black;
  padding: 2px 8px;
`;

const DeploymentFooter = () => {
  const [backendVersions, setBackendBackendVersions] = useState<BackendVersions>();

  const {carecoApi} = useContext(CarecoApiContext);

  useEffect(() => {
    if (!carecoApi) {
      return;
    }

    carecoApi.getBackendVersions()
      .then(backendVersion => {
        setBackendBackendVersions(backendVersion);
      }).catch(error => {
        log('error',"Error fetching back end version: " + error);
      });
  }, [carecoApi]);

  return (
    <Wrapper>
      <Table>
        <thead>
          <tr>
            <HeaderCell/>
            <HeaderCell>
              Branch
            </HeaderCell>
            <HeaderCell>
              Commit
            </HeaderCell>
          </tr>
        </thead>
        <tbody>
          <tr>
            <Cell>
              careco-ui
            </Cell>
            <Cell>
              {process.env.REACT_APP_GIT_BRANCH || 'local'}
            </Cell>
            <Cell>
              {process.env.REACT_APP_GIT_COMMIT || 'local'}
            </Cell>
          </tr>
          <tr>
            <Cell>
              careco-webapp
            </Cell>
            <Cell>
              { backendVersions?.carecoWebapp?.GIT_BRANCH || '???' }
            </Cell>
            <Cell>
              { backendVersions?.carecoWebapp?.GIT_COMMIT || '???' }
            </Cell>
          </tr>
          <tr>
            <Cell>
              careco-events
            </Cell>
            <Cell>
              { backendVersions?.carecoEvents?.GIT_BRANCH || '???' }
            </Cell>
            <Cell>
              { backendVersions?.carecoEvents?.GIT_COMMIT || '???' }
            </Cell>
          </tr>
          <tr>
            <Cell>
              thoth
            </Cell>
            <Cell>
              { backendVersions?.thoth?.GIT_BRANCH || '???' }
            </Cell>
            <Cell>
              { backendVersions?.thoth?.GIT_COMMIT
                ? <>
                  {backendVersions.thoth.GIT_COMMIT}
                  {backendVersions.thoth.dirty &&
                      <InfoIconTooltip
                        style={{marginLeft: '5px'}}
                        text="Deployed with uncommitted local changes"
                        size="xs"
                        position="right" />}
                </>
                : '???' }
            </Cell>
          </tr>
          <tr>
            <Cell>
              client-workflow-engine
            </Cell>
            <Cell>
              { backendVersions?.clientWorkflowEngine?.GIT_BRANCH || '???' }
            </Cell>
            <Cell>
              { backendVersions?.clientWorkflowEngine?.GIT_COMMIT || '???' }
            </Cell>
          </tr>
        </tbody>
      </Table>
    </Wrapper>
  );
};

export default DeploymentFooter;
